import { useState } from "react";
import { Copy, Check, Mail, MapPin } from "lucide-react";
import Reveal from "./Reveal";

const EMAIL = "contact@adminlogicservicesltd.com";

const Cta = () => {
    const [copied, setCopied] = useState(false);

    const copyEmail = async () => {
        try {
            await navigator.clipboard.writeText(EMAIL);
            setCopied(true);
            setTimeout(() => setCopied(false), 2200);
        } catch (e) {
            setCopied(false);
        }
    };

    return (
        <section id="contact" data-testid="cta-section" className="relative overflow-hidden py-24 lg:py-32">
            <div
                aria-hidden="true"
                className="pointer-events-none absolute bottom-[-30%] left-1/2 h-[500px] w-[900px] -translate-x-1/2 rounded-full opacity-25"
                style={{
                    background: "radial-gradient(circle at center, rgba(59,130,246,0.55), rgba(245,158,11,0.15) 50%, transparent 72%)",
                    filter: "blur(50px)",
                }}
            />
            <div className="relative mx-auto max-w-7xl px-6 lg:px-10">
                <Reveal>
                    <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-amber-400">
                        04 — Contact
                    </p>
                    <h2 className="mt-6 max-w-3xl font-display text-3xl font-bold tracking-tight sm:text-4xl lg:text-6xl">
                        Let&apos;s put your back office{" "}
                        <span className="bg-gradient-to-r from-electric-glow to-amber-400 bg-clip-text text-transparent">
                            in order.
                        </span>
                    </h2>
                    <p className="mt-6 max-w-xl text-base leading-relaxed text-slate-400">
                        Tell us what is piling up — inbox, invoices, filings, diaries — and we will
                        take it from there.
                    </p>
                </Reveal>

                <div className="mt-14 grid gap-6 lg:grid-cols-2">
                    <Reveal delay={0.05}>
                        <div
                            data-testid="cta-email-card"
                            className="glass-card flex h-full flex-col justify-between rounded-2xl p-8"
                        >
                            <div className="flex items-center gap-3">
                                <Mail className="h-5 w-5 text-electric-glow" />
                                <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-slate-400">
                                    Email us
                                </p>
                            </div>
                            <p className="mt-6 break-all font-mono text-lg text-white sm:text-xl">
                                {EMAIL}
                            </p>
                            <div className="mt-8 flex flex-wrap items-center gap-4">
                                <button
                                    data-testid="cta-copy-email-btn"
                                    onClick={copyEmail}
                                    className={`flex items-center gap-2 rounded-full px-6 py-3 text-sm font-bold uppercase tracking-wider transition-all duration-300 ${
                                        copied
                                            ? "bg-emerald-400 text-navy"
                                            : "bg-amber-400 text-navy hover:bg-amber-300 hover:shadow-[0_0_30px_rgba(245,158,11,0.35)]"
                                    }`}
                                >
                                    {copied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}
                                    {copied ? "Copied" : "Copy address"}
                                </button>
                                <a
                                    href={`mailto:${EMAIL}`}
                                    className="text-sm font-semibold text-slate-300 underline decoration-electric/50 underline-offset-4 transition-colors hover:text-white"
                                >
                                    Or open in your mail app
                                </a>
                            </div>
                        </div>
                    </Reveal>

                    <Reveal delay={0.12}>
                        <div className="glass-card flex h-full flex-col justify-between rounded-2xl p-8">
                            <div className="flex items-center gap-3">
                                <MapPin className="h-5 w-5 text-electric-glow" />
                                <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-slate-400">
                                    Registered office
                                </p>
                            </div>
                            <address className="mt-6 not-italic text-base leading-relaxed text-slate-200 sm:text-lg">
                                Admin Logic Services Ltd
                                <br />
                                71-75 Shelton Street,
                                <br />
                                Covent Garden,
                                <br />
                                London,
                                <br />
                                WC2H 9JQ
                            </address>
                            <p className="mt-8 font-mono text-[11px] uppercase tracking-[0.22em] text-slate-500">
                                Registered in England &amp; Wales · Company No. 17432590
                            </p>
                        </div>
                    </Reveal>
                </div>
            </div>
        </section>
    );
};

export default Cta;
